import Vue from "vue";
if (document.getElementById("login")) {
  var login = new Vue({
    el: "#login",
    data: {
      test: "efef",
      login: null
    },
    mounted() {
      if (window.localStorage.getItem("login")) {
        this.login = window.localStorage.getItem("login");
      }
    },
    methods: {
      enter() {
        window.localStorage.setItem("login", this.login);
      }
    }
  });
}
